import request from '@/config/axios'

export type FavoritesVO = {
  id: number
  contentId: number
  seriesId: number
  seasonId: number
  name: string
  coverUrl: string
  audioUrl: string
  videoUrl: string
  category?: string
  chinese?: string
  english?: string
  isFavorite?: number
  createTime: string
}

export const addFavorites = (data: any) => {
  return request.post({
    url: '/user-favorites/create',
    data
  })
}

export const getFavoritesPage = (params: any) => {
  return request.get({
    url: '/user-favorites/page',
    params
  })
}

export const getFavorites = (contentType: number, contentId: number) => {
  return request.get({
    url: '/user-favorites/get?contentType=' + contentType + '&contentId=' + contentId
  })
}

export const deleteFavorites = (contentType: number, contentId: number) => {
  return request.delete({
    url: '/user-favorites/delete?contentType=' + contentType + '&contentId=' + contentId
  })
}

export const batchDeleteFavorites = (ids: number[]) => {
  return request.delete({
    url: `/user-favorites/delete-list?ids=${ids.join(',')}`
  })
}
